// Cross-widget messaging for the agent-board surfaces.
//
// Widgets stay decoupled — no shared store, no parent coordination — by
// publishing typed window events that other widgets subscribe to. This is
// deliberately small: only events that genuinely need cross-widget
// coordination should be added here. Status counts and rollups are still
// done via shared SWR cache keys, not events.

const INSPECT_TASK_EVENT = 'agent-board:inspect-task';

export interface InspectTaskDetail {
  taskUuid: string;
  /** Optional source for debugging — which widget asked. */
  source?: string;
}

/** Ask the Agent Run Inspector to load runs for a given task UUID. */
export function emitInspectTask(detail: InspectTaskDetail): void {
  window.dispatchEvent(
    new CustomEvent<InspectTaskDetail>(INSPECT_TASK_EVENT, { detail }),
  );
}

/** Subscribe to inspect-task requests. Returns an unsubscribe function. */
export function onInspectTask(
  handler: (detail: InspectTaskDetail) => void,
): () => void {
  function listener(e: Event) {
    const detail = (e as CustomEvent<InspectTaskDetail>).detail;
    if (detail && typeof detail.taskUuid === 'string') {
      handler(detail);
    }
  }
  window.addEventListener(INSPECT_TASK_EVENT, listener);
  return () => window.removeEventListener(INSPECT_TASK_EVENT, listener);
}
